import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Transfer = () => {
  return <ErpTablePage moduleKey="inv_transfer" />;
};

export default Transfer;